module.exports = __webpack_public_path__ + "static/img/baxi.a568b62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/baxi.jpg
// module id = XcQP
// module chunks = 0